import { render } from "./CompSectionTubeComponent.vue?vue&type=template&id=1a95710e&scoped=true"
import script from "./CompSectionTubeComponent.vue?vue&type=script&lang=js"
export * from "./CompSectionTubeComponent.vue?vue&type=script&lang=js"

import "./CompSectionTubeComponent.vue?vue&type=style&index=0&id=1a95710e&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a95710e"]])

export default __exports__